module.exports = __webpack_public_path__ + "static/media/car-engine-blue.edfdf9d4.svg";